<template>
  <div>
    <b-row>
      <b-col
        v-for="panel in dashboard.panels"
        :key="panel.id"
        cols="12"
        md="6"
        class="mb-1-5 row-height"
      >
        <CustomPanel :panel="panel" :timeRange="timeRange"></CustomPanel>
      </b-col>
      <b-col cols="12" md="6" class="mb-1-5 row-height">
        <AddPanelButton @add="openCreateModal"></AddPanelButton>
      </b-col>
    </b-row>
    <AddPanelModal
      :dashboardId="dashboardId"
      ref="createModal"
      @added="handleAdded"
      @closed="handleClosed"
    />
  </div>
</template>

<script>
import AddPanelButton from '@/xvisor/components/custom/AddPanelButton.vue';
import AddPanelModal from '@/xvisor/components/custom/AddPanelModal.vue';
import CustomPanel from '@/xvisor/components/custom/CustomPanel.vue';
import PanelEventBus from '@/xvisor/bus/PanelEventBus';

// import dashboardDetails from '@/xvisor/components/custom/dashboard.json';

export default {
  components: {
    AddPanelButton,
    AddPanelModal,
    CustomPanel,
  },
  props: {
    dashboardId: {
      type: Number,
      required: true,
    },
    timeRange: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dashboardUrl: `/dashboards/${this.dashboardId}/details.json`,
      dashboard: {
        panels: [],
      },
    };
  },
  methods: {
    openCreateModal() {
      this.$refs.createModal.show();
    },
    handleAdded() {
    },
    handleClosed() {
    },
    httpGet() {
      // this.dashboard = dashboardDetails;
      this.$http
        .get(this.dashboardUrl)
        .then((response) => {
          this.dashboard = response.data;
        });
    },
  },
  mounted() {
    PanelEventBus.$on('added', this.httpGet);
    PanelEventBus.$on('deleted', this.httpGet);
    this.httpGet();
  },
};
</script>

<style scoped>
.row-height {
  height: 50vh;
}
</style>
